"use client";

import { cn } from "@/util";
import type { PropsWithChildren } from "react";

export const Container = ({
  children,
  disableVerticalPadding,
}: PropsWithChildren & { disableVerticalPadding?: boolean }) => (
  <div
    className={cn(
      "container mx-auto px-4",
      !disableVerticalPadding && "pt-10 md:pt-20"
    )}
  >
    {children}
  </div>
);
